import React from "react";
import '../styles/teamReveal.css';
import renuka from './Images/RENUKA WANKHADE.jpg'
import pranav from './Images/Pranav_Malvi.jpg'
import prasanna from './Images/PrasannaPatwardhan.jpg';
import shubham from './Images/SHUBHAM GORADE.png';
import ayushi from './Images/AAYUSHI MAINDALKAR.jpg';
import yash from './Images/YASH SAROLKAR.jpg';
import meet from './Images/Meet Oza.jpg';
import srushti from './Images/SRUSHTI GHOGARE.jpg';
import rujuta from './Images/Rujuta Bhanose.jpg';
import kunal from './Images/KUNAL SURYAWANSHI.jpg';
import nikhil from './Images/Nikhil Jumbad.jpg';
import haamid from './Images/HAAMID SYED.png';
import aaryan from './Images/Aaryan Gupta.jpeg';
import mangesh from './Images/Mangesh Thakare.jpeg';
import sakshi from './Images/SAKSHI KOTHAWADE.jpg';
import prachee from './Images/PRACHEE PRASAD.jpg';
import krishna from './Images/KRISHNA BIHANI.jpg';
import isha from './Images/ISHA  VARADE.jpg';
import aditee from './Images/ADITEE MOHANTY.jpeg';
import apurva from './Images/Apurva Dabhade.jpg';
import archit from './Images/ARCHIT GUPTA.jpg';
import tanish from './Images/Tanish_Kulkarni.jpg';
import siddant from './Images/Siddhant Tade.jpg';
import manthan from './Images/Manthan.jpg';
import ishan from './Images/ISHAN PANTAWANE.jpg';
import saburi from './Images/SABURI KALE.jpg';
import ronit from './Images/Ronit Tambekar.png';
import shantanu from './Images/SHANTANU KHODKE.jpg';
import kartik from './Images/Kartik Shinde.PNG';
import jigar from './Images/Jigar Prajapati.jpg';
import samiksha from './Images/SAMIKSHA SURWASE.jpg';
import vidhan from './Images/VIDHAN MANIHAR.jpg';
import gaurav from './Images/GAURAV KAUSHALYE.jpg';
import anisha from './Images/ANISHA SHENDE.jpg';
import ananya from './Images/BISHT ANANYA.jpg';
import gaurav2 from './Images/Gaurav Sharma.png';
import om from './Images/Om Gole.jpg';
import arjun from './Images/ARJUN SALUNKE.JPEG';
import sneha from './Images/SNEHA MULEY.jpg';
import riya from './Images/RIYA MOTA.jpg';
import shlok from './Images/SHLOK BIYANI.jpg';
import pranav2 from './Images/PRANAV ATTARDE.jpg';
import samyak from './Images/SAMYAK DUGAD.jpg';
import laboneey from './Images/LABONEEY DHANURE.jpg';
import daksh from './Images/DAKSHAGARWAL.jpg';
import shreya from './Images/SHREYA PATIL.jpg';
import vedant from "./Images/Vedant Ahire_GFG.jpg";
import UserNav from "./UserNav";


const TeamReveal = ()=>{

    return(<>
    <UserNav/>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"></link>
        <div className="heading">
<h1 >Our Core Team</h1></div>

<div className="card-container">
    <div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={renuka} alt="Yash Gupta"/>
        </div>
        
    </div>
    <h1>Renuka Wankhade</h1>
    <p>President</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/renuka-wankhade/"><i className="fab fa-linkedin"></i></a>
        
        <a href="https://www.instagram.com/renuuka.a/"><i className="fab fa-instagram"></i></a>
    </div>
</div>
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={pranav} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Pranav Malvi</h1>
    <p>Vice President</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/pranav-malvi-55bb41256/"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/pranav.1221/"><i className="fab fa-instagram"></i></a>
    </div>
</div>
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={prasanna} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Prasanna Patwardhan </h1>
    <p>General Manager</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/prasanna-patwardhan-24782228b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/prasannapp100?igsh=NHo4OXB2NHFnN2ht"><i className="fab fa-instagram"></i></a>
    </div>
</div>

</div>

<div className="card-container">
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={shubham} alt="Yash Gupta"/>
        </div>
    </div>

    <h1>Shubham Gorade</h1>
    <p>Secretary</p>
    <div className="social-bar">
        <a href="http://www.linkedin.com/in/shubham-gorade-11a194286"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/shubham_gorade_1001?igsh=MXh4em5jaDl0eHpmZg=="><i className="fab fa-instagram"></i></a>
    </div>
</div>


<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={ayushi} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Aayushi Maindalkar</h1>
    <p>Associate Secretary</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/aayushi-maindalkar-a034a6281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
        <a href="https://www.instagram.com/aayushimaindalkar_?igsh=cnZweGVzZWlraGc4"><i className="fab fa-instagram"></i></a>
    </div>
</div>
</div>


<div className="heading">
    <h1 >Our Community Team</h1></div>
    <div className="card">
        <div className="top-semi-circle"></div>
        <div className="outer-circle">
            <div className="inner-circle">
                <img src={yash} alt="Yash Gupta"/>
            </div>
        </div>
        <h1>Yash Sarolkar</h1>
        <p>Community lead </p>
        <div className="social-bar">
            <a href="https://www.linkedin.com/in/yash-sarolkar-60284b25b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
            
            <a href="https://www.instagram.com/yash__sarolkar/"><i className="fab fa-instagram"></i></a>
        </div>
    </div>
    
<div className="card-container">
    <div className="card">
        <div className="top-semi-circle"></div>
        <div className="outer-circle">
            <div className="inner-circle">
                <img src={meet} alt="Yash Gupta"/>
            </div>
        </div>
        <h1>Meet Oza</h1>
        <p>Community Co-Lead</p>
        <div className="social-bar">
            <a href="http://linkedin.com/in/meetoza30"><i className="fab fa-linkedin"></i></a>
          
            <a href="http://instagram.com/meetoza30"><i className="fab fa-instagram"></i></a>
        </div>
    </div>
    
    <div className="card">
        <div className="top-semi-circle"></div>
        <div className="outer-circle">
            <div className="inner-circle">
                <img src={srushti} alt="Yash Gupta"/>
            </div>
        </div>
        <h1>Srushti Ghogare</h1>
        <p>Community Co-Lead</p>
        <div className="social-bar">
            <a href="https://www.linkedin.com/in/srushti-ghogare-986581290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
           
            <a href="https://www.instagram.com/srushtighogare22?igsh=dTYxdXc1dHQ1M2o5"><i className="fab fa-instagram"></i></a>
        </div>
    </div>
    <div className="card">
        <div className="top-semi-circle"></div>
        <div className="outer-circle">
            <div className="inner-circle">
                <img src={rujuta} alt="Yash Gupta"/>
            </div>
        </div>
        <h1>Rujuta Bhanose</h1>
        <p>Community Co-Lead</p>
        <div className="social-bar">
            <a href="https://www.linkedin.com/in/rujuta-bhanose-0a1b84292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
            
            <a href="https://www.instagram.com/rujutaa_b?igsh=MTBnZmZoM3Jycmx1MQ=="><i className="fab fa-instagram"></i></a>
        </div>
    </div>
    </div>



<div className="heading">
<h1 >Our Techical Team</h1></div>
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={kunal} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Kunal Suryawanshi</h1>
    <p>Technical Head </p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/kunal-suryawanshi-943827259"><i className="fab fa-linkedin"></i></a>
        
        <a href="https://www.instagram.com/kunalsuryawanshi999"><i className="fab fa-instagram"></i></a>
    </div>
</div>

<div className="card-container">
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={nikhil} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Nikhil Jumbad</h1>
    <p>Technical Associate</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/nikhil-jumbad/"><i className="fab fa-linkedin"></i></a>
      
        <a href="https://www.instagram.com/nikhilj_005?igsh=bHBheGFlajFlbTN4"><i className="fab fa-instagram"></i></a>
    </div>
</div>

<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={haamid} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Haamid Syed</h1>
    <p>Technical Associate</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/haamid-syed-1584a3311?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/haamid.fr?igsh=eDNqMXo2eXhycDZn"><i className="fab fa-instagram"></i></a>
    </div>
</div>
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={aaryan} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Aaryan Gupta</h1>
    <p>Technical Associate</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/aaryan-gupta-9b1a00295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><i className="fab fa-linkedin"></i></a>
        
        <a href="https://www.instagram.com/aaryyan_g?igsh=MTd4aDl0bW9rd2I5OQ%3D%3D&utm_source=qr"><i className="fab fa-instagram"></i></a>
    </div>
</div>
</div>




    <div className="heading">
        <h1 >Our Event Team</h1></div>
        <div className="card">
            <div className="top-semi-circle"></div>
            <div className="outer-circle">
                <div className="inner-circle">
                    <img src={mangesh} alt="Yash Gupta"/>
                </div>
            </div>
            <h1>Mangesh Thakare</h1>
            <p>Event Head </p>
            <div className="social-bar">
                <a href="https://www.linkedin.com/in/mangesh-thakare-739ab125a/"><i className="fab fa-linkedin"></i></a>
                
{/*                 <a href="https://www.instagram.com/kunalsuryawanshi999"><i className="fab fa-instagram"></i></a> */}
            </div>
        </div>
        
    <div className="card-container">
        <div className="card">
            <div className="top-semi-circle"></div>
            <div className="outer-circle">
                <div className="inner-circle">
                    <img src={sakshi} alt="Yash Gupta"/>
                </div>
            </div>
            <h1>Sakshi Kothawade</h1>
            <p>Event Associate</p>
            <div className="social-bar">
                <a href="https://www.linkedin.com/in/sakshi-kothawade-402612290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
              
                <a href="https://www.instagram.com/sakshikothawade_14/"><i className="fab fa-instagram"></i></a>
            </div>
        </div>
        
        <div className="card">
            <div className="top-semi-circle"></div>
            <div className="outer-circle">
                <div className="inner-circle">
                    <img src={prachee} alt="Yash Gupta"/>
                </div>
            </div>
            <h1>Prachee Prasad</h1>
            <p>Event Associate</p>
            <div className="social-bar">
                <a href="http://www.linkedin.com/in/prachee-prasad-421012294"><i className="fab fa-linkedin"></i></a>
               
                <a href="https://www.instagram.com/prch._?igsh=aGdzaHJ6YmttYTBr&utm_source=qr"><i className="fab fa-instagram"></i></a>
            </div>
        </div>
        <div className="card">
            <div className="top-semi-circle"></div>
            <div className="outer-circle">
                <div className="inner-circle">
                    <img src={krishna} alt="Yash Gupta"/>
                </div>
            </div>
            <h1>Krishna Bihani</h1>
            <p>Event Associate</p>
            <div className="social-bar">
                <a href="https://www.linkedin.com/in/krishna-bihani-38bb45272?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                
                <a href="https://www.instagram.com/krishnabihani_23?igsh=NWllcW96ZjVvZ3Vi"><i className="fab fa-instagram"></i></a>
            </div>
        </div>
        </div>


        <div className="heading">
            <h1 >Our Design Team</h1></div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={isha} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Isha Varade</h1>
                <p>Design Head</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/isha-varade-0191a22aa?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/isha__varade/"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            
        <div className="card-container">
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={aditee} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Aditee Mohanty </h1>
                <p>Design Associate</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/aditee-mohanty-1471bb293/"><i className="fab fa-linkedin"></i></a>
                  
                    <a href="https://www.instagram.com/aditee_mohanty?igsh=MXhkNHJwdWlxb3Q0aQ=="><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={apurva} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Apurva Dabhade</h1>
                <p>Design Associate</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/apurva-dabhade-14969a295/"><i className="fab fa-linkedin"></i></a>
                   
                    <a href="https://www.instagram.com/apurvadabhade?igsh=NmdveW1zanc2dnox"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={archit} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Archit gupta</h1>
                <p>Design Associate</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/archit-gupta-77b287251/"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/__architgupta_/"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={tanish} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Tanish Kulkarni</h1>
                <p>Design Associate</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/tanish-kulkarni-190440304?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/coolkarni_tanish005?utm_source=qr&igsh=OWdjNXljeDZidThn"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            </div>


            <div className="heading">
                <h1 >Our Multimedia & Cinematography Team</h1></div>
                <div className="card">
                    <div className="top-semi-circle"></div>
                    <div className="outer-circle">
                        <div className="inner-circle">
                            <img src={siddant} alt="Yash Gupta"/>
                        </div>
                    </div>
                    <h1>Siddhant Tade</h1>
                    <p>Multimedia and cinematography head</p>
                    <div className="social-bar">
                        <a href="https://www.linkedin.com/in/siddhant-tade-b7073327a/"><i className="fab fa-linkedin"></i></a>
                        
                        <a href="https://www.instagram.com/siddhanttade?igsh=ajVqcXd1cHhqZTBs"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
                
            <div className="card-container">
                <div className="card">
                    <div className="top-semi-circle"></div>
                    <div className="outer-circle">
                        <div className="inner-circle">
                            <img src={manthan} alt="Yash Gupta"/>
                        </div>
                    </div>
                    <h1>Manthan Badgujar</h1>
                    <p>Multimedia Associate</p>
                    <div className="social-bar">
                        <a href="https://www.linkedin.com/in/manthan-badgujar-550b4b292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                      
                        <a href="https://www.instagram.com/mxnthnn.5?igsh=NXFteDgwdGV1Z2x2"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
                
                <div className="card">
                    <div className="top-semi-circle"></div>
                    <div className="outer-circle">
                        <div className="inner-circle">
                            <img src={ishan} alt="Yash Gupta"/>
                        </div>
                    </div>
                    <h1>Ishan Pantawane</h1>
                    <p>Multimedia Associate</p>
                    <div className="social-bar">
                        <a href="https://www.linkedin.com/in/ishaan-pantawane-1135b5295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                       
                        <a href="https://www.instagram.com/ishaan__236/"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
                <div className="card">
                    <div className="top-semi-circle"></div>
                    <div className="outer-circle">
                        <div className="inner-circle">
                            <img src={saburi} alt="Yash Gupta"/>
                        </div>
                    </div>
                    <h1>Saburi Kale</h1>
                    <p>Multimedia Associate</p>
                    <div className="social-bar">
                        <a href="https://www.linkedin.com/in/saburi-kale-3393a3300?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                        
                        <a href="https://www.instagram.com/saburi._.13?igsh=MTQ0ZjlxaXJlY244MA=="><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
                
                </div>
                <div className="card-container">
                    <div className="card">
                        <div className="top-semi-circle"></div>
                        <div className="outer-circle">
                            <div className="inner-circle">
                                <img src={ronit} alt="Yash Gupta"/>
                            </div>
                        </div>
                        <h1>Ronit Tambekar</h1>
                        <p>Cinematography Associate</p>
                        <div className="social-bar">
                            <a href="https://www.linkedin.com/in/ronit-tambekar-367483298?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                          
                            <a href="https://www.instagram.com/ronit_a.t?igsh=MXQxZDA4NXBvcTFpZA=="><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    
                    <div className="card">
                        <div className="top-semi-circle"></div>
                        <div className="outer-circle">
                            <div className="inner-circle">
                                <img src={shantanu} alt="Yash Gupta"/>
                            </div>
                        </div>
                        <h1>Shantanu Khodke</h1>
                        <p>Cinematography Associate</p>
                        <div className="social-bar">
                            <a href="https://www.linkedin.com/in/shantanu-khodke/"><i className="fab fa-linkedin"></i></a>
                           
                            <a href="https://www.instagram.com/shantastic.k?igsh=dmp0enp0c3ZiaXZ3"><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="top-semi-circle"></div>
                        <div className="outer-circle">
                            <div className="inner-circle">
                                <img src={kartik} alt="Yash Gupta"/>
                            </div>
                        </div>
                        <h1>Kartik Shinde</h1>
                        <p>Cinematography Associate</p>
                        <div className="social-bar">
                            <a href="https://www.linkedin.com/in/kartik-shinde-6b98701a6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><i className="fab fa-linkedin"></i></a>
                            
                            <a href="https://www.instagram.com/kartik_shinde13?igsh=d3JpbXdldjVhejJh&utm_source=qr"><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    
                    </div>



                    <div className="heading">
                        <h1 >Our Finance Team</h1></div>
                        <div className="card">
                            <div className="top-semi-circle"></div>
                            <div className="outer-circle">
                                <div className="inner-circle">
                                    <img src={jigar} alt="Yash Gupta"/>
                                </div>
                            </div>
                            <h1>Jigar Prajapati</h1>
                            <p>Finance Manager</p>
                            <div className="social-bar">
                                <a href="https://www.linkedin.com/in/jigar-prajapati-23713224a"><i className="fab fa-linkedin"></i></a>
                                
                                <a href="https://www.instagram.com/jigar926?igsh=bGp1YWRxb2cweHNq"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        
                    <div className="card-container">
                        <div className="card">
                            <div className="top-semi-circle"></div>
                            <div className="outer-circle">
                                <div className="inner-circle">
                                    <img src={samiksha} alt="Yash Gupta"/>
                                </div>
                            </div>
                            <h1>Samiksha Surwase</h1>
                            <p>Finance Associate</p>
                            <div className="social-bar">
                                <a href="https://www.linkedin.com/in/samiksha-surwase-a2a836290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                              
                                <a href="https://www.instagram.com/samikshas_20?igsh=NzN6N25sYjkzdHBp"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        
                        <div className="card">
                            <div className="top-semi-circle"></div>
                            <div className="outer-circle">
                                <div className="inner-circle">
                                    <img src={vidhan} alt="Yash Gupta"/>
                                </div>
                            </div>
                            <h1>Vidhan Manihar</h1>
                            <p>Finance Associate</p>
                            <div className="social-bar">
                                <a href="https://www.linkedin.com/in/vidhan-manihar-7a6953289?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                               
                                <a href="https://www.instagram.com/vidhanmanihar?igsh=MXV5MGhpYmFkOXZz"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        <div className="card">
                            <div className="top-semi-circle"></div>
                            <div className="outer-circle">
                                <div className="inner-circle">
                                    <img src={gaurav} alt="Yash Gupta"/>
                                </div>
                            </div>
                            <h1>Gaurav Kaushalye</h1>
                            <p>Finance Associate</p>
                            <div className="social-bar">
                                <a href="https://www.linkedin.com/in/gaurav-kaushalye/"><i className="fab fa-linkedin"></i></a>
                                
                                <a href="https://www.instagram.com/kaushalye_gaurav/"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        


                        </div>
                        <div className="heading">
                            <h1 >Our Departmental coordinator's </h1></div>
                            <div className="card">
                                <div className="top-semi-circle"></div>
                                <div className="outer-circle">
                                    <div className="inner-circle">
                                        <img src={anisha} alt="Yash Gupta"/>
                                    </div>
                                </div>
                                <h1>Anisha Shende</h1>
                                <p>CS Department Head</p>
                                <div className="social-bar">
                                    <a href="https://www.linkedin.com/in/anishashende"><i className="fab fa-linkedin"></i></a>
                                    
                                    <a href="https://instagram.com/anishaashende?igshid=MW5icHNxaWZ0NDd1dQ=="><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            
                        <div className="card-container">
                            <div className="card">
                                <div className="top-semi-circle"></div>
                                <div className="outer-circle">
                                    <div className="inner-circle">
                                        <img src={ananya} alt="Yash Gupta"/>
                                    </div>
                                </div>
                                <h1>Ananya Bisht</h1>
                                <p>CS Department Associate</p>
                                <div className="social-bar">
                                    <a href="https://www.linkedin.com/in/ananya-bisht-134470319?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                  
                                    <a href="https://www.instagram.com/ya_bishtie?igsh=MTRsMmN0NWI4MmFldA=="><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            
                            
                            <div className="card">
                                <div className="top-semi-circle"></div>
                                <div className="outer-circle">
                                    <div className="inner-circle">
                                        <img src={gaurav2} alt="Yash Gupta"/>
                                    </div>
                                </div>
                                <h1>Gaurav Sharma</h1>
                                <p>CS Department Associate</p>
                                <div className="social-bar">
                                    <a href="http://www.linkedin.com/in/gaurav-sharma-b73a241aa"><i className="fab fa-linkedin"></i></a>
                                    
                                    <a href="https://www.instagram.com/vogauravjosharmatanahi?igsh=Z2U4OHF1c3Budnc%3D&utm_source=qr"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            
                            </div>
                
                                <div className="card">
                                    <div className="top-semi-circle"></div>
                                    <div className="outer-circle">
                                        <div className="inner-circle">
                                            <img src={om} alt="Yash Gupta"/>
                                        </div>
                                    </div>
                                    <h1>Om Gole</h1>
                                    <p>IT Department Head</p>
                                    <div className="social-bar">
                                        <a href="http://www.linkedin.com/in/om-gole-viit"><i className="fab fa-linkedin"></i></a>
                                        
                                        <a href="https://www.instagram.com/om_gole125?igsh=OXh3c2Jjd3dqYzls"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                
                            <div className="card-container">
                                <div className="card">
                                    <div className="top-semi-circle"></div>
                                    <div className="outer-circle">
                                        <div className="inner-circle">
                                            <img src={arjun} alt="Yash Gupta"/>
                                        </div>
                                    </div>
                                    <h1>Arjun Salunke</h1>
                                    <p>IT Department Associate</p>
                                    <div className="social-bar">
                                        <a href="https://www.linkedin.com/in/arjun-salunke-4ab012326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                      
                                        <a href="https://www.instagram.com/arjun_salunke15?utm_source=qr&igsh=MW9neDRtMnBrdWF6aQ=="><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                
                                
                                <div className="card">
                                    <div className="top-semi-circle"></div>
                                    <div className="outer-circle">
                                        <div className="inner-circle">
                                            <img src={sneha} alt="Yash Gupta"/>
                                        </div>
                                    </div>
                                    <h1>Sneha Muley</h1>
                                    <p>IT Department Associate</p>
                                    <div className="social-bar">
                                        <a href="https://www.linkedin.com/in/sneha-muley-a4a00a325"><i className="fab fa-linkedin"></i></a>
                                        
                                        <a href="https://www.instagram.com/sneha_muley_?igsh=MTlmcDQ3bDBnbHdtbA=="><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                
                                </div>
                                <div className="heading">
                                    </div>
                                    <div className="card">
                                        <div className="top-semi-circle"></div>
                                        <div className="outer-circle">
                                            <div className="inner-circle">
                                                <img src={riya} alt="Yash Gupta"/>
                                            </div>
                                        </div>
                                        <h1>Riya Mota</h1>
                                        <p>CSE(AI-ML) Department Head</p>
                                        <div className="social-bar">
                                            <a href="https://www.linkedin.com/in/riya-mota-2383b1254?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                            
                                            <a href="https://www.instagram.com/riya__mota?igsh=eXNwdHoydWpyZHRx"><i className="fab fa-instagram"></i></a>
                                        </div>
                                    </div>
                                    
                                <div className="card-container">
                                    <div className="card">
                                        <div className="top-semi-circle"></div>
                                        <div className="outer-circle">
                                            <div className="inner-circle">
                                                <img src={shlok} alt="Yash Gupta"/>
                                            </div>
                                        </div>
                                        <h1>Shlok Biyani</h1>
                                        <p>CSE(AI-ML) Department Associate</p>
                                        <div className="social-bar">
                                            <a href="https://www.linkedin.com/in/shlok-biyani-03654029a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                          
                                            <a href="https://www.instagram.com/shlok_biyani_?igsh=MWo5emY1OHF1Z3h4Yw=="><i className="fab fa-instagram"></i></a>
                                        </div>
                                    </div>
                                    
                                    
                                    <div className="card">
                                        <div className="top-semi-circle"></div>
                                        <div className="outer-circle">
                                            <div className="inner-circle">
                                                <img src={pranav2} alt="Yash Gupta"/>
                                            </div>
                                        </div>
                                        <h1>Pranav Attarde</h1>
                                        <p>CSE(AI-ML) Department Associate</p>
                                        <div className="social-bar">
                                            <a href="https://www.linkedin.com/in/pranav-attarde"><i className="fab fa-linkedin"></i></a>
                                            
                                            <a href="https://www.instagram.com/pranav__attarde?igsh=MXA3Z2prd2NzNzRuYQ=="><i className="fab fa-instagram"></i></a>
                                        </div>
                                    </div>
                                    
                                    </div>
                                    <div className="card-container">
                                        <div className="card">
                                            <div className="top-semi-circle"></div>
                                            <div className="outer-circle">
                                                <div className="inner-circle">
                                                    <img src={samyak} alt="Yash Gupta"/>
                                                </div>
                                            </div>
                                            <h1>Samyak Dugad</h1>
                                            <p>CSE(SE) Department Associate</p>
                                            <div className="social-bar">
                                                <a href="https://www.linkedin.com/in/samyak-dugad-a0202b28b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                              
                                                <a href="https://www.instagram.com/samyak_8505/"><i className="fab fa-instagram"></i></a>
                                            </div>
                                        </div>
                                        
                                        
                                        <div className="card">
                                            <div className="top-semi-circle"></div>
                                            <div className="outer-circle">
                                                <div className="inner-circle">
                                                    <img src={laboneey} alt="Yash Gupta"/>
                                                </div>
                                            </div>
                                            <h1>Laboneey Dhanure</h1>
                                            <p>CSE(SE) Department Associate</p>
                                            <div className="social-bar">
                                                <a href="https://www.instagram.com/laboneeydhanure?igsh=MWFpbTd6dTZ0eWR5MA=="><i className="fab fa-linkedin"></i></a>
                                                
                                                <a href="https://www.linkedin.com/in/laboneey-dhanure-a31576292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-instagram"></i></a>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card-container">
                                            <div className="card">
                                                <div className="top-semi-circle"></div>
                                                <div className="outer-circle">
                                                    <div className="inner-circle">
                                                        <img src={daksh} alt="Yash Gupta"/>
                                                    </div>
                                                </div>
                                                <h1>Daksh Agarwal</h1>
                                                <p>AIDS Department Associate</p>
                                                <div className="social-bar">
                                                    <a href="https://www.linkedin.com/in/daksh-agarwal-391438281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                                  
                                                    <a href="https://www.instagram.com/dakshagarwal.23/"><i className="fab fa-instagram"></i></a>
                                                </div>
                                            </div>
                                            
                                            
                                            <div className="card">
                                                <div className="top-semi-circle"></div>
                                                <div className="outer-circle">
                                                    <div className="inner-circle">
                                                        <img src={shreya} alt="Yash Gupta"/>
                                                    </div>
                                                </div>
                                                <h1>Shreya Patil</h1>
                                                <p>AIDS Department Associate</p>
                                                <div className="social-bar">
                                                    <a href="https://www.linkedin.com/in/shreya-patil-b4b61428a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                                                    
                                                    <a href="https://www.instagram.com/_shreya___patil_?igsh=MWw2MHptZ2JuMjVucQ=="><i className="fab fa-instagram"></i></a>
                                                </div>
                                            </div>
                                            </div>

                                        
    </>)
}

export default TeamReveal
